import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1038px;
  width: 100%;
  margin-top: 3%;
`;
export const CardPersonalInformation = styled.div`
  background-color: #fff;
  width: '100%';
  padding: 10px;
  border-bottom: 1px solid ${theme.greenDefault};
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${theme.white};
  align-items: center;
`;

export const DisplayInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0px;
`;
export const CustomButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border: 1px solid ${(props) => props.border || 'black'};
  border-radius: 4px;
  color: ${(props) => props.color || 'black'};
  background-color: ${(props) => props.background || '#fff'};
  font-weight: 400;

  &:hover {
    filter: brightness(0.95);
  }
`;

export const CadastrarListaLegacyLink = styled.a`
  &:hover {
    text-decoration: none;
  }
`;
export const HoverActions = styled.div`
  padding: 5px;
  margin-right: 10px;
  &:hover {
    background-color: ${theme.greenDefault};
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    word-break: normal;

    svg {
      color: #fff !important;

      /*  path {
        fill: #fff !important;
      } */
    }
  }
`;
